import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, Redirect, Route } from 'react-router';
import { MapActionsObject, StoreState } from 'types';
import { isLoggedIn, isLocaleLoaded } from 'store/selectors';
import { userChecked } from 'store/actions';
import { loadable } from 'helpers/component';

import { DASHBOARD } from 'constants/routes';
import * as ROUTES from './routes';
import Header from './Header';
import Signup from './Signup';
import SignupSuccess from './SignupSuccess';
import EmailVerified from './Confirmation/Email';
import Login from './Login';

import styles from './Onboarding.module.scss';

const Authorize = loadable(() => import(/* webpackChunkName: "authorize" */ './Authorize'));
const PasswordReset = loadable(() => import(/* webpackChunkName: "password-reset" */ './Reset'));
const PasswordChange = loadable(() => import(/* webpackChunkName: "password-change" */ './Change'));
const ConfirmationExpired = loadable(() =>
  import(/* webpackChunkName: "confirmation-expired" */ './Confirmation/Expired'));
const ConfirmationVerified = loadable(() =>
  import(/* webpackChunkName: "confirmation-verified" */ './Confirmation/Verified'));

type Props = {
};

const select = (state: StoreState) => ({
  isAuthenticated: isLoggedIn(state),
  isLocaleLoaded: isLocaleLoaded(state),
});

const mapActions = {
  userChecked,
};

type MappedProps = ReturnType<typeof select>;
type MappedActions = MapActionsObject<typeof mapActions>;

class Onboarding extends React.Component<MappedProps & MappedActions & Props & RouteComponentProps> {
  render() {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) return <Redirect to={ DASHBOARD } />;

    return (
      <div className={ styles.wrapper }>
        <Header route={ this.props.location.pathname } history={ this.props.history } />
        <div className="container">
          <Route
            path={ ROUTES.SIGNUP_SUCCESS }
            exact={ true }
            component={ SignupSuccess }
          />
          <Route
            path={ ROUTES.SIGNUP }
            exact={ true }
            component={ Signup }
          />
          <Route
            path={ ROUTES.LOGIN }
            render={ (props) => <Login { ...{ ...props, userChecked: this.props.userChecked } } /> }
          />
          <Route path={ ROUTES.AUTHORIZE } component={ Authorize } />
          <Route path={ ROUTES.PASSWORD_RESET } component={ PasswordReset } />
          <Route path={ ROUTES.PASSWORD_CHANGE } component={ PasswordChange } />
          <Route path={ ROUTES.CONFIRMATION_EXPIRED } component={ ConfirmationExpired } />
          <Route path={ ROUTES.CONFIRMATION_VERIFIED } component={ ConfirmationVerified } />
          <Route path={ ROUTES.EMAIL_VERIFIED } component={ EmailVerified } />
        </div>
      </div>
    );
  }
}

export default connect<MappedProps, typeof mapActions, Props, StoreState>(
  select,
  mapActions,
)(Onboarding);
